export const FILTER_COL = {
  xl: 'auto',
  lg: 'auto',
  md: 6,
  sm: 6,
  cols: 12,
  class: 'd-flex align-center'
}
export const FILTER_ACTION_COL = {
  cols: 12,
}